import { Inventory2Outlined as GearIcon } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import { useDirection } from '../../context/DirectionContext';
import { translate as tr } from '../../i18n/translations';
import { Station } from '../../types/api';
import { combineGear } from '../../utils/stationGuidance';

/** One added-up gear list for all of a cycle's stations (P2). */
const CombinedGearCard: React.FC<{ stations: Station[] }> = ({ stations }) => {
  const { lang } = useDirection();
  const gear = combineGear(stations.map(s => s.infoForEvaluator));

  return (
    <Box sx={{ bgcolor: 'white', border: '1px solid #E2E8F0', borderRadius: 3, p: 2.5, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <GearIcon fontSize="small" sx={{ color: '#64748B' }} />
        <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', color: '#0F172A' }}>{tr('guide.combinedGear', lang)}</Typography>
      </Box>
      {gear.length === 0 ? (
        <Typography sx={{ color: '#94A3B8', fontSize: '0.875rem' }}>{tr('guide.noGear', lang)}</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {gear.map(g => (
            <Chip key={g.item} label={`${g.item} × ${g.quantity}`} size="small" variant="outlined" />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CombinedGearCard;
